import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { translate } from '../../modules/helper-functions'
import SearchResultCarousel from './SearchResultCarousel'
import { ratio, getSpaceAreaRange, getPropertyPostTypeSlug } from '../../search-common/helpers'
import { colors, fontFamilies } from '../../search-common/settings'

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: ${ratio( 2, 1 )}%;
  min-height: 200px;
  background: linear-gradient(to right, ${colors.grayTone1} 40%, ${colors.blackTwo} 50%, ${colors.grayTone1} 60%);
  background-size: 400%;
  ${( props ) => !props.imageLoaded && `
    animation: placeholderAnimation 2s ease infinite;
    @keyframes placeholderAnimation {
      0%{background-position:0% 50%}
      50%{background-position:100% 50%}
      100%{background-position:0% 50%}
    }
  `}
`

const Content = styled.a`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 20px 60px;
  display: grid;
  cursor: pointer;
  text-decoration: none;
  align-content: end;
  grid-template-areas:
  "name     name"
  "address  address"
  "area     location";
  background: linear-gradient(to top, ${colors.grayTone1}, ${colors.grayTone1}99 20%, transparent 40%);
`

const BuildingName = styled.span`
  background-color: ${colors.blackTwo};
  font-family: ${fontFamilies.aeonik};
  font-size: 13px;
  font-weight: bold;
  color: ${colors.white};
  padding: 6px 12px;
  text-transform: uppercase;
  z-index: 1;
  justify-self: start;
  grid-area: name;
`

const StreetAddress = styled.h3`
  grid-area: address;
  font-family: ${fontFamilies.aeonik};
  font-size: 24px;
  font-weight: bold;
  width: 100%;
  color: ${colors.white};
`

const SpaceArea = styled.div`
  grid-area: area;
  font-family: ${fontFamilies.aeonik};
  font-size: 16px;
  color: ${( props ) => props.notAvailable ? colors.red : colors.white};
`

const Location = styled.div`
  grid-area: location;
  justify-self: end;
  font-family: ${fontFamilies.aeonik};
  font-style: normal;
  font-size: 16px;
  color: ${colors.white};
`

/**
 * SearchResultWide component.
 */
const SearchResultWide = ({ result, images, locale, notAvailable, translations }) => {
  const [ imageLoaded, setImageLoaded ] = useState( false )

  return (
    <Container imageLoaded={imageLoaded}>
      <SearchResultCarousel width={200} height={100} images={images} setImageLoaded={setImageLoaded} />
      <Content href={`/${getPropertyPostTypeSlug( locale )}/${result.slug2}`}>
        {result.name
          ? <BuildingName>{result.name}</BuildingName>
          : null
        }
        <StreetAddress>{result.address}</StreetAddress>
        <SpaceArea notAvailable={notAvailable} >{notAvailable ? translate( translations, 'No available spaces' ) : getSpaceAreaRange( result.spaces )}</SpaceArea>
        <Location>{result.neighborhood},<br />{result.zip_code} {result.city}</Location>
      </Content>
    </Container>
  )
}


SearchResultWide.propTypes = {
  result: PropTypes.object.isRequired,
  images: PropTypes.array,
  locale: PropTypes.string.isRequired,
  notAvailable: PropTypes.bool,
  translations: PropTypes.object.isRequired
}

export default SearchResultWide
